import * as Yup from "yup";

import { castInputToNumber, createForm } from "../../forms";

import {
  INCOME_TYPE_TRANSLATION_KEYS,
  INCOME_REPORTING_INDUSTRY_CHOICES,
} from "./constants";

import type { IncomeReportingFormValues, IncomeTypeChoice } from "./types";

export const incomeReportingValidationSchema =
  Yup.object<IncomeReportingFormValues>().shape({
    income: Yup.number()
      .transform(castInputToNumber)
      .required("Required")
      .min(1, "Please enter a positive amount"),
    incomeType: Yup.string()
      .required("Required")
      .oneOf(Object.keys(INCOME_TYPE_TRANSLATION_KEYS), "Required"),
    mortgageRent: Yup.number()
      .transform(castInputToNumber)
      .min(0, "Please enter a valid amount")
      .optional(),
    industry: Yup.string()
      .oneOf(
        Object.keys(INCOME_REPORTING_INDUSTRY_CHOICES),
        "Please select one of the available industries",
      )
      .optional(),
    occupation: Yup.string()
      .max(128, "Must be 128 characters or fewer")
      .optional(),
  });

export const incomeReportingFormInitialValues: IncomeReportingFormValues = {
  // Providing the undefined here allows the form to recognize there is no input yet
  income: undefined as unknown as number,
  incomeType: "" as IncomeTypeChoice,
};

export const incomeReportingForm = createForm<IncomeReportingFormValues>({
  initialValues: incomeReportingFormInitialValues,
  validationSchema: incomeReportingValidationSchema,
});
